export const InvoicesMyFiltersStorageKey = 'invoicesMyFilters';
export const CourierPickupFiltersStorageKey = 'CourierPickupFiltersStorageKey';
export const InvoicesTemplateFiltersStorageKey = 'invoicesTemplateFilters';
export const InternationalInvoiceTemplateFiltersStorageKey = 'internationalInvoicesTemplateFilters';
